import { useBraidTheme } from "../BraidProvider/BraidThemeContext.mjs";
const useThemeName = () => useBraidTheme().name;
export {
  useThemeName
};
